<div class="sliding-panes" *ngIf="tsReady">
    <div class="sliding-pane" [ngClass]="{'slide-left': !showNotificationsList}">

        <ui-card type="clear">
            <card-header class="bordered">
                <div class="card-details">
                    <h3 class="title">{{'notification.main.title' | translate}}</h3>
                    <span *ngIf="notifs.count !== 0 && notifs.count" class="color-shade-60 b2" [innerHTML]="'notifications.count' | translate: {number: notifs.count}"></span>
                </div>
                <div class="card-actions" *ngIf="notifs.list.length > 0">
                    <ui-dropdown>
                        <ui-list dropdown-menu role="menu">
                            <button ui-list-item *ngIf="notifs.count !== 0 && notifs.count" (click)="markNotificationsAsRead();">{{'notification.mark.read' | translate}}</button>
                            <button ui-list-item (click)="deleteNotifications();">{{'notification.delete' | translate}}</button>
                        </ui-list>
                    </ui-dropdown>
                </div>
            </card-header>

            <card-body class="p-0" *ngIf="notifs.list">

                <ui-list class="default" *ngIf="notifs.list.length !== 0">

                    <ng-container *ngFor="let group of notifsGrouped">
                        <ui-list-item role="header">
                            <div class="px-2 uppercase b2" [innerHTML]="group.days_ago === 0 ? ('notifications.main.today' | translate) : (group.days_ago === 1 ? ('optimizer.time.day.ago' | translate) : ('optimizer.time.days.ago' | translate: {days:  group.days_ago}))"></div>
                        </ui-list-item>

                        <ui-list-item (click)="toggleDetails(notification)"
                            *ngFor="let notification of group.notifs; let i = index"
                            [disabled]="notification.ack">


                            <ui-icon [type]="notification.interface.icon.type" *ngIf="notification.interface.icon else other" [icon]="notification.interface.icon.value"  size="40" shape="circle" bg="inherit"></ui-icon>

                            <ng-template #other>
                                <ui-avatar *ngIf="notification?.interface?.user_avatar" [avatar]="notification.interface.user_avatar" size="38" shape="circle" bg="shade-40"></ui-avatar>
                                <ui-icon *ngIf="!notification?.interface?.user_avatar"
                                    type="device-v2"
                                    [icon]="notification.interface.device_icon ?? 'other' "  size="40" shape="circle" bg="inherit">
                                </ui-icon>
                            </ng-template>

                            <div class="details">
                                <p id="p_1573196580_{{i + 1}}" class="title mb-1 word-break" [ngClass]="{'strong': !notification.ack}">
                                    <!-- {{i}} - ({{notification.ack === true ? 'citita' : 'necitita'}}) -->
                                    {{notification.interface.title.charAt(0).toUpperCase() + notification.interface.title.slice(1)}}</p>
                                <div class="row justfy-end b2">
                                    <p class="color-shade-60 col">
                                        {{ notification.interface.device_deleted ? ('device.removed' | translate) : notification.app_fields?.time_ago }}
                                    </p>
                                    <p *ngIf="notification.interface.user_name" class="color-shade-60 col-auto">
                                        {{notification.interface.user_name}}
                                    </p>
                                    <!-- Btn 'View Issues' for 'issues' notifications -->
                                    <button *ngIf="notification?.app_fields?.notification_params?.notification_type === notificationTypeIssues"
                                        class="color-danger col-auto"
                                        (click)="navigateToDeviceDetails(notification)">
                                        <span class="b2 ml-1">{{'notifications.issues.new.issues.main_button' | translate}}</span>
                                        <i class="connect_icon_right ml-1"></i>
                                    </button>
                                    <!-- Btn 'View Request' for 'need_more_time' request -->
                                    <button *ngIf="(notification?.app_fields?.notification_params?.notification_type === notificationTypeParental
                                        || notification?.app_fields?.notification_params?.notification_type === notificationTypeNcc)
                                        && notification?.app_fields?.notification_params?.notification_subtype === notificationSubtypeNeedMoreTime"
                                        class="color-danger col-auto"
                                        (click)="navigateToNccChildProfile(notification)">
                                        <span class="b2 ml-1">{{'notifications.parental.need_more_time.main_button' | translate}}</span>
                                        <i class="connect_icon_right ml-1"></i>
                                    </button>
                                </div>
                            </div>

                        </ui-list-item>
                    </ng-container>


                    <ui-list-item role="footer" class="justify-content-center">
                        <button ui-button model="discrete" color="primary" [disabled]="notifs.final"
                            (click)="moreListItems()">{{'notification.button.show.more' | translate}}</button>
                    </ui-list-item>

                </ui-list>

                <empty-state *ngIf="notifs.list.length === 0" icon="connect_icon_notification" [title]="'notifications.empty' | translate" type="card"></empty-state>

            </card-body>

        </ui-card>
    </div>

    <div class="sliding-pane" [ngClass]="{'slide-right': !showNotificationDetails}">
        <app-notification-details (back)="showList($event)" [notification]="notificationDetails"
            *ngIf="showNotificationDetails">
        </app-notification-details>
    </div>
</div>